import { QueryBuilder, QueryFilter } from '@softline/core';
import { ApiRow } from '../types/api-row';
import { SalesStatisticsQueryService } from '../services/sales-statistics-query.service';

export function applyActiveFilters(
  builder: QueryBuilder<ApiRow>,
  queryService: SalesStatisticsQueryService
): void {
  for (const f of queryService.activeFilters()) {
    builder.filter(f as unknown as QueryFilter<ApiRow>);
  }
}
